import React from "react";
import {SearchBox, withSearch} from "@elastic/react-search-ui";
import SearchFormComponent from "./SearchFormComponent";

const SelectCategoryComponent = () => {
  return (
    <>
      <SearchBox
        autocompleteSuggestions={true}
        view={(props) => (
          <SearchFormComponent {...props} />
        )}
      />
    </>
  );
};

const SelectCategory = withSearch(({setFilter, filters, removeFilter}) => ({
  setFilter,
  filters,
  removeFilter,
}))(SelectCategoryComponent);

const OmronSearchBox = () => {
  return (
    <div>
      <SelectCategory />
    </div>
  );
};

export default OmronSearchBox;
